import type { CloudConnectionType } from "~/client/resources/stepPackage";
import { session } from "~/clientInstance";

export const getKubernetesTargetDiscoveryCloudProviders: () => Array<CloudConnectionType> = () => (session.features?.IsKubernetesCloudTargetDiscoveryEnabled ? ["Aws", "Azure"] : []);
